import { TWarehouse } from 'types/warehouse';

import { CRMAPIBase } from '@api/crmApiBase';
import { RequestResult } from '@api/responseModels/requestResult';
import { WarehouseListResp } from '@api/responseModels/warehouse/warehousesListResponse';
import { WarehouseResp } from '@api/responseModels/warehouse/warehousesResponse';

class WarehousesGroup extends CRMAPIBase {
    async getWarehousesList(params: { crm_id: number }): Promise<RequestResult<WarehouseListResp>> {
        const result = await this.get<WarehouseListResp>(`/warehouses`, params);
        return result;
    }

    async getWarehouse(params: {
        id: number;
        crm_id: number;
    }): Promise<RequestResult<WarehouseResp>> {
        const crm_id = params.crm_id;
        const result = await this.get<WarehouseResp>(`/warehouses/${params.id}`, { crm_id });
        return result;
    }

    async createWarehouse(wareehouse: TWarehouse): Promise<RequestResult<WarehouseResp>> {
        const result = await this.post<WarehouseResp>(`/warehouses`, wareehouse);
        return result;
    }

    async updateWarehouse(wareehouse: TWarehouse): Promise<RequestResult<WarehouseResp>> {
        const result = await this.put<WarehouseResp>(`/warehouses/${wareehouse.id}`, wareehouse);
        return result;
    }

    async deleteWarehouse(params: {
        id: number;
        crm_id: number;
    }): Promise<RequestResult<WarehouseResp>> {
        const crm_id = params.crm_id;
        const result = await this.delete<WarehouseResp>(`/warehouses/${params.id}`, { crm_id });
        return result;
    }
}
export { WarehousesGroup };
